import { PointsBundle } from '../../types/PointsBundle';

export const buyPremiumBook199Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.1.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_199',
  tags: [],
};

export const buyPremiumBook299Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.2.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_299',
  tags: [],
};

export const buyPremiumBook399Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.3.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_399',
  tags: [],
};

export const buyPremiumBook499Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.4.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_499',
  tags: [],
};

export const buyPremiumBook599Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.5.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_599',
  tags: [],
};

export const buyPremiumBook699Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.6.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_699',
  tags: [],
};

export const buyPremiumBook799Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.7.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_799',
  tags: [],
};

export const buyPremiumBook899Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.8.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_899',
  tags: [],
};

export const buyPremiumBook999Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.9.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_999',
  tags: [],
};

export const buyPremiumBook1099Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.10.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1099',
  tags: [],
};

export const buyPremiumBook1199Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.11.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1199',
  tags: [],
};

export const buyPremiumBook1299Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.12.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1299',
  tags: [],
};

export const buyPremiumBook1399Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.13.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1399',
  tags: [],
};

export const buyPremiumBook1499Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.14.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1499',
  tags: [],
};

export const buyPremiumBook1599Bundle: PointsBundle = {
  id: 'com.colt.app.buypremiumbook.15.99',
  adjustEventId: 'ry12g5',
  tiers: 0,
  title: 'premium book',
  description: 'product_premium_book_1599',
  tags: [],
};

export const buyFullBook499GalateaBundle: PointsBundle = {
  id: 'com.colt.app.buyfullbook.4.99',
  adjustEventId: 'p2ol19',
  tiers: 0,
  title: 'thriller book',
  description: 'product_thriller_book',
  tags: [],
};

export const buyFullBook299GalateaBundle: PointsBundle = {
  id: 'com.colt.app.buyfullbook.2.99',
  adjustEventId: 'p2ol19',
  tiers: 0,
  title: 'non thriller book',
  description: 'non_product_thriller_book',
  tags: [],
};
